import { Segmented, TimePicker } from 'antd';
import { USER_TIME_FORMAT } from 'shared/constants/date';
import type { SegmentedValue } from 'antd/lib/segmented';
import type { RangePickerProps } from 'antd/es/date-picker';
import type { ColumnsType } from 'antd/es/table';
import type { TeacherWorkloadWorkDayFormRow } from 'entities/teacher-workload/form/types';
import type { WorkDayTableRecord } from './types';
import styles from '../ui/styles.module.scss';
import { MODE_OPTIONS } from './config';
import { toRangeValue } from './utils';

type GetWorkDaysColumnsParams = {
  rows: TeacherWorkloadWorkDayFormRow[];
  onModeChange: (index: number, mode: SegmentedValue) => void;
  onTimeRangeChange: (index: number, range: RangePickerProps['value'] | null) => void;
};

export const getWorkDaysColumns = ({
  rows,
  onModeChange,
  onTimeRangeChange,
}: GetWorkDaysColumnsParams): ColumnsType<WorkDayTableRecord> => [
  {
    title: 'День',
    dataIndex: 'dayLabel',
    width: 120,
    className: styles.colDay,
  },
  {
    title: 'Режим',
    key: 'mode',
    width: 370,
    render: (_, record) => {
      const row = rows[record.index];
      if (!row) return null;
      return (
        <Segmented
          block
          className={styles.segmented}
          options={MODE_OPTIONS}
          value={row.mode}
          onChange={(v) => onModeChange(record.index, v)}
        />
      );
    },
  },
  {
    title: 'Время',
    key: 'time',
    width: 200,
    align: 'center',
    render: (_, record) => {
      const row = rows[record.index];
      if (!row || row.mode !== 'interval') {
        return <span className={styles.timePlaceholder}>—</span>;
      }
      return (
        <TimePicker.RangePicker
          allowClear
          className={styles.timeRange}
          format={USER_TIME_FORMAT}
          minuteStep={5}
          value={toRangeValue(row.startTime, row.endTime)}
          onChange={(range) => onTimeRangeChange(record.index, range ?? null)}
        />
      );
    },
  },
];
